import { render } from "./page-recomend-url.vue?vue&type=template&id=2bc065a9&scoped=true"
import script from "./page-recomend-url.vue?vue&type=script&lang=js"
export * from "./page-recomend-url.vue?vue&type=script&lang=js"

import "./page-recomend-url.vue?vue&type=style&index=0&id=2bc065a9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc065a9"]])

export default __exports__